import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

export abstract class AbstractCRUDService<Type, Key> implements Injectable {

	protected readonly httpClient: HttpClient;

	protected constructor(httpClient: HttpClient) {
		this.httpClient = httpClient;
	}

	public abstract async getAllAsync(): Promise<Type[]>;

	public abstract async getByIdAsync(id: Key): Promise<Type>;

}



// WEBPACK FOOTER //
// ./Frontend/src/app/services/AbstractCRUDService.ts